import router from "@/router"
import Vue from 'vue'

function decodeIssuedToken(token) {
    let [header, payload, signature] = token.split('.')
    header = signature = payload = JSON.parse(atob(payload))
    return payload
}

const mutations = {
    BRANCH_VERSION(state, payload) {
        state.programVersion = payload.programVersionInfo ?
            payload.programVersionInfo.productVersionTypeCode : null
    },
    RESET_PAGE(state, payload) {
        state.pageStatus = null
        state.extraStatus = null
        state.loadingStatus = false
        state.sysBarStatus = false
        state.sysBarMessage = null
        state.sysBarColor = null
        state.sysBarInset = null
        state.subNaviStatus = false
        state.subNaviPage = null
        state.extraPageName = null
        state.stateFullHeight = false
    },
    SET_TOKEN(state, payload) {
        let atk = decodeIssuedToken(payload.accessToken)
        let rtk = decodeIssuedToken(payload.refreshToken)

        localStorage.clear()

        // Storage에 저장
        localStorage.setItem('accessToken', payload.accessToken)
        localStorage.setItem('refreshToken', payload.refreshToken)
        sessionStorage.setItem("rdu", btoa("n").replace(/=/g, ""))

        // Store에 저장
        state.accessToken = payload.accessToken
        state.refreshToken = payload.refreshToken
        state.tokenIat = atk.iat
        state.tokenExp = atk.exp
        state.refreshIat = rtk.iat
        state.refreshExp = rtk.exp
    },
    SET_LOGIN_INFO(state, payload) {
        let atk = decodeIssuedToken(payload.accessToken)
        console.log('luidx저장', Number(atob(atk.umc)))
        console.log('cbidx저장', Number(atob(atk.cbc)))
        state.uuid = atk.sub
        state.luidx = Number(atob(atk.umc))
        state.cbidx = Number(atob(atk.cbc))
        state.isLogined = true
    },
    SET_REFRESH_INFO(state, payload) {
        state.uuid = payload.uuid
        state.luidx = payload.luidx
        state.cbidx = payload.cbidx
        state.isLogined = true
    },
    USER_INFO(state, payload) {
        state.userInfo = payload.userDetailInfo
        state.permissionInfo = payload.permissionInfo
        state.allBranch = payload.staffs
    },
    LOGOUT(state) {
        // Storage 초기화
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        sessionStorage.removeItem('rdu')
            // remove vuex status values
        localStorage.removeItem('_secure__ls__metadata')
        localStorage.removeItem('vuex')

        localStorage.clear()

        // Store 로그인정보 초기화
        state.accessToken = null
        state.refreshToken = null
        state.uuid = null
        state.luidx = null
        state.cbidx = null
        state.accessToken = null
        state.refreshToken = null
        state.tokenIat = null
        state.tokenExp = null
        state.refreshIat = null
        state.refreshExp = null
        state.isLogined = false

        // 로그인 유저정보 초기화
        state.userInfo = null
        router.push({ name: 'Login' }).catch(() => {})
        location.reload()
            // setTimeout(() => {
            //     // location.reload()
            //     router.push({ name: 'Login'}).catch(()=>{})
            // }, 1000)
    },
    SUB_NAVI_STATUS(state, payload) {
        state.subNaviStatus = payload
    },
    SUB_NAVI_PAGE(state, payload) {
        state.subNaviPage = payload
    },
    PAGE_STATUS(state, payload) {
        switch (payload) {
            case 'SeniorDashboard':
                state.leftPageDrawer = true;
                break
            case 'RecipientDashboard':
                state.leftPageDrawer = true;
                break
            case 'EmployeeDashboard':
                state.leftPageDrawer = true;
                break
            case 'BranchDashboard':
                state.leftPageDrawer = true;
                break
            case 'FinancialDashboard':
                state.leftPageDrawer = false;
                break
            case 'AuthorizationDashboard':
                state.leftPageDrawer = true;
                break
            default:
                state.leftPageDrawer = false;
        }
        state.pageStatus = payload
    },
    LEFT_LIST_PAGE_STATUS(state, payload) {
        state.leftPageDrawer = payload
    },
    EXTRA_STATUS(state, payload) {
        state.extraStatus = payload
    },
    EXTRA_PAGENAME(state, payload) {
        state.extraPageName = payload
    },
    // EXTRA_APPROVAL_NAME(state, payload) {
    //     state.approvalName = payload.name
    //     state.electapFormIdx = payload.idx
    // },
    CLOSE_EXTRA(state) {
        state.extraPageName = null
        state.extraStatus = null
            // state.approvalName = null
            // state.electapFormIdx = null
    },
    OPEN_LOADING(state) {
        state.loadingStatus = true
    },
    CLOSE_LOADING(state) {
        state.loadingStatus = false
    },
    OPEN_SYSTEM_BAR(state, payload) {
        // check system bar is shown before
        if (state.sysBarStatus) state.sysBarStatus = false
            //check margin left whether side navigation is existed
        if (typeof payload.inset === 'undefined') payload.inset = true

        // state.sysBarStatus = true
        state.sysBarMessage = payload.message
        state.sysBarColor = payload.color
        state.sysBarInset = payload.inset

        Vue.notify({
            group: 'momsby',
            type: (payload.color === 'warn' || payload.color === 'warning') ? 'warn' : payload.color,
            duration: 5000,
            text: payload.message,
            icon: payload.icon ? payload.icon : 'task_alt'
        })
    },
    SHOW_MESSAGE(state, payload) {
        if (state.sysBarStatus) state.sysBarStatus = false
        if (typeof payload.inset === 'undefined') payload.inset = true

        Vue.notify({
            group: 'momsby',
            type: (payload.color === 'warn' || payload.color === 'warning') ? 'warn' : payload.color,
            color: (payload.color === 'warn' || payload.color === 'warning') ? 'warn' : payload.color,
            duration: (payload.duration) ? payload.duration : 5000,
            text: payload.message,
            icon: payload.icon ? payload.icon : 'task_alt'
        })
    },
    SHOW_SUB_MESSAGE(state, payload) {
        if (state.sysBarStatus) state.sysBarStatus = false
        if (typeof payload.inset === 'undefined') payload.inset = true

        Vue.notify({
            group: 'sub-momsby',
            type: (payload.color === 'warn' || payload.color === 'warning') ? 'warn' : payload.color,
            color: (payload.color === 'warn' || payload.color === 'warning') ? 'warn' : payload.color,
            duration: (payload.duration) ? payload.duration : 5000,
            text: payload.message,
            icon: payload.icon ? payload.icon : 'task_alt'
        })
    },
    CLOSE_SYSTEM_BAR(state) {
        state.sysBarStatus = false
        state.sysBarMessage = null
        state.sysBarColor = null
    },
    AUTH_DATA(state, payload) {
        localStorage.clear()

        state.authData.mobileNo = payload.info.mobileNo
        state.authData.authCodeSendIdx = payload.data.authCodeSendIdx
        state.authData.authCode = payload.data.authCode
        state.authData.userIdx = payload.data.userIdx
        state.authData.gubun = payload.info.gubun
    },
    RESET_AUTH_DATA(state) {
        state.authData = {
            mobileNo: null,
            authCodeSendIdx: null,
            authCode: null,
            userIdx: null,
            gubun: null,
        }
    },
    CHECK_USER_INFO(state, payload) {
        state.userTempInfo.userIdx = payload.data.userIdx
        state.userTempInfo.userName = payload.info.userName
        state.userTempInfo.birthday = payload.info.birthday
        state.userTempInfo.password = payload.info.password
        state.userTempInfo.oldMobileNo = payload.info.oldMobileNo
        state.userTempInfo.mobileNo = payload.info.mobileNo
        state.userTempInfo.residentRegistrationNumber = payload.info.residentRegistrationNumber
    },
    QR_LOGIN_CODE(state, payload) {
        state.qrcode = payload.qrCodeInfo.qrcode
        state.qrcodeLoginIdx = payload.qrCodeInfo.qrcodeLoginIdx
    },
    CLEAR_SEARCH_BRANCH_KEYWORD(state) {
        state.customerBranchList = null
    },
    SEARCH_BRANCH(state, payload) {
        if (payload) {
            state.customerBranchList = payload.data.instituteList
            state.branchSearchStatus = false
        } else {
            state.customerBranchList = null
            state.branchSearchStatus = true
        }
    },
    RESET_BRANCH(state) {
        state.customerBranchList = null
        state.branchSearchStatus = true
    },
    SEARCH_ADDRESS(state, payload) {
        if (payload.data.documents.length !== 0) {
            state.searchRoadNameList = payload.data.documents
            state.roadNameSearchStatus = false
        } else {
            state.searchRoadNameList = null
            state.roadNameSearchStatus = true
        }
    },
    RESET_ADDRESS(state) {
        state.searchRoadNameList = null
        state.roadNameSearchStatus = false
    },
    BRANCH_INFO(state, payload) {
        state.branchInfo = payload.customerInfo
        state.branchInfo.ssisLoginPwd = state.branchInfo.ssisLoginPwd?atob(decodeURIComponent(state.branchInfo.ssisLoginPwd)):null
        if (payload.logoFile && payload.logoFile.logoFileIdx) {
            state.branchLogo = payload.logoFile
        } else {
            state.branchLogo = null
        }
    },
    UPLOAD_LOGO(state, payload) {
        state.branchLogo = payload.logoFile
    },
    DELETE_LOGO(state) {
        state.branchLogo = null
    },
    OFFICE_SEAL(state, payload) {
        if (payload.customerBranchFile && payload.customerBranchFile.officeSealFileIdx) {
            state.branchOfficeSeal = payload.customerBranchFile
        } else {
            state.branchOfficeSeal = null
        }
    },
    DELETE_OFFICE_SEAL(state) {
        state.branchOfficeSeal = null
    },
    MY_SIGNATURE(state, payload) {
        state.mySign = payload.digitalSignature
    },
    REGIST_MY_SIGNATURE(state, payload) {
        state.mySign = payload.digitalSignature
    },
    DELETE_MY_SIGNATURE(state) {
        state.mySign = null
    },
    COMMON_SIGNATURE(state, payload) {
        // recipient or guardian signature
        state.commonSign = payload.digitalSignature
    },
    PERSON_SIGNATURE(state, payload) {
        state.thirdPersonSign = payload.digitalSignature
    },
    REGIST_MY_IMAGE(state, payload) {
        state.userInfo.userImagePath = `/v1/auth/display/${payload.uploadFilePath}`
    },
    DELETE_MY_IMAGE(state) {
        state.userInfo.userImagePath = null
    },
    CHANGE_STATE_FULL_HEIGHT(state, payload) {
        state.stateFullHeight = payload
    },
    CHANGE_PAGE_VIEW_TYPE(state, payload) {
        state.pageViewType = payload
    },
    MY_EMPLOYMENT_CONTRACTS(state, payload) {
        state.myContracts = payload.contractList
    },
    CHANGE_PRINT_CONTRACT_INFO(state, payload) {
        state.showPrintContractNo = payload
    },
    // MY_PAYSLIPS(state, payload) {
    //     state.myPayslips = payload.thisPayslipList
    // },
    GET_CONNECT_CERT(state, payload) {
        state.connectLTC = payload.LTC
        state.connectW4C = payload.W4C
    },
    GUARDIAN_SIGN_LIST(state, payload) {
        state.guardianSignList = payload.signList
    },
    SMS_PRE_INFO(state, payload) {
        if (payload && payload.remainInfo)
            state.remainInfo = payload.remainInfo

        if (payload && payload.smsPhones)
            state.smsPhones = payload.smsPhones
    },
    SMS_USER_LIST(state, payload) {
        state.smsUserList = payload.smsUserList
        if (state.smsUserList) {
            state.smsUserList.forEach((item, i) => {
                item['id'] = i
            })
        }
    },
    SET_SMS_USER_FILTER(state, payload) {
        state.userFilter = payload
    },
    SEND_SMS(state, payload) {
        state.remainInfo = payload.remainInfo
    },
    SMS_PAYMENT_INFO(state, payload) {
        state.serviceInfo = payload.serviceList
    },
    GUARDIAN_SIGN_DEFAULT(state, payload) {
        state.defaultInfo = payload.userInfo
        state.defaultBranch = payload.customerBranchInfo
    },
    SET_REMAIN_INFO(state, payload) {
        state.remainInfo = payload
    },
    SMS_TEMPLETE(state, payload) {
        state.smsTemplete = payload.smsSendPhraseList
    },
    REGIST_SMS_TEMPLETE(state, payload) {
        if (state.smsTemplete) {
            let index = state.smsTemplete.findIndex(item => item.smsSendPhraseIdx === payload.smsSendPhrase.smsSendPhraseIdx)
            if (index !== -1) {
                state.smsTemplete.splice(index, 1, payload.smsSendPhrase)
            } else {
                state.smsTemplete.push(payload.smsSendPhrase)
            }
        } else {
            if (!state.smsTemplete) state.smsTemplete = []
            state.smsTemplete.push(payload.smsSendPhrase)
        }
    },
    DEFAULT_SMS_TEMPLETE(state, payload) {
        let index = state.smsTemplete.findIndex(item => item.smsSendPhraseIdx === payload.smsSendPhrase.smsSendPhraseIdx)
        if (payload.smsSendPhrase.defaultYn === 'Y') {
            state.smsTemplete.forEach(item => {
                if (item.smsCategoryCode === payload.smsSendPhrase.smsCategoryCode) {
                    item.defaultYn = 'N'
                }
            })
            state.smsTemplete.splice(index, 1, payload.smsSendPhrase)
        } else {
            state.smsTemplete[index].defaultYn = 'N'
        }
    },
    SMS_TEMPLETE_BOOKMARK(state, payload) {
        state.smsTemplete[payload.index].bookmarkYn = payload.yn
    },
    DELETE_SMS_TEMPLETE(state, payload) {
        state.smsTemplete.splice(payload, 1)
        if (!state.smsTemplete.length) state.smsTemplete = null
    },
    COMMON_HOLIDAY(state, payload) {
        state.commonHoliday = payload.holidayList
    },
    BUSINESS_DAY(state, payload)  {
        state.businessDay = payload.businessDayList
    }
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/default/mutations.js